/**
 * Day-change notifier: dispatches a 'dayChanged' CustomEvent on window when the
 * calendar day changes (e.g. after midnight). Other components can listen with
 * window.addEventListener('dayChanged', handler) and remove in onUnmounted.
 */

const EVENT_NAME = 'dayChanged'

function getDateString() {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

/**
 * Start the day-change notifier.
 * @param {Object} options
 * @param {number} [options.checkIntervalMs=60000] - How often to check the date (default 60s).
 * @returns {function} stop() - Call to clear the interval and stop the notifier.
 */
export function startDayChangeNotifier(options = {}) {
  const { checkIntervalMs = 60000 } = options
  let lastKnownDate = getDateString()

  const tick = () => {
    const today = getDateString()
    if (today !== lastKnownDate) {
      lastKnownDate = today
      window.dispatchEvent(
        new CustomEvent(EVENT_NAME, { detail: { date: today } })
      )
    }
  }

  const intervalId = setInterval(tick, checkIntervalMs)

  return function stop() {
    clearInterval(intervalId)
  }
}
